import { REGEX } from '@/constants/regex';
import { SVTextInput } from '..';
import { formatCurrencyWithIconInput } from '@/utils/currency';
import { Typography } from '@mui/material';
import { InputRules } from '@/types/inputs';

type SVCurrencyInputProps = {
  name: string;
  label: string;
  required?: boolean;
  rules?: InputRules;
  hideLabel?: boolean;
  disabled?: boolean;
};

export default function SVCurrencyInput({
  name,
  label,
  required = true,
  rules,
  hideLabel = false,
  disabled = false,
}: SVCurrencyInputProps) {
  return (
    <SVTextInput
      htmlInputProps={{
        inputMode: 'numeric',
      }}
      valueFormatter={formatCurrencyWithIconInput}
      name={name}
      label={label}
      disabled={disabled}
      hideLabel={hideLabel}
      rules={{
        required: required,
        ...rules,
        validate: (value: string) => {
          if (!value) return true;

          const rawValue = value.replace(/[,\s]/g, '');
          if (!REGEX.CURRENCY_VALUE.test(rawValue)) {
            return `${label} must be a valid currency amount`;
          }

          const numericValue = parseFloat(rawValue);
          if (numericValue < 0) {
            return `${label} must be greater than or equal to 0`;
          }

          // Handle min/max validation for currency values
          if (rules?.min !== undefined || rules?.max !== undefined) {
            if (rules?.min !== undefined && numericValue < rules.min) {
              return `${label} must be at least ${rules.min}`;
            }
            if (rules?.max !== undefined && numericValue > rules.max) {
              return `${label} must be no more than ${rules.max}`;
            }
          }

          return true;
        },
      }}
      inputProps={{ startAdornment: <Typography>$</Typography> }}
    />
  );
}
